export class FormGroupStatus {
  static VALID = 'VALID';
  static INVALID = 'INVALID';
  static PENDING = 'PENDING';
  static DISABLED = 'DISABLED';
}
